import midarImg from '@/assets/images/prjects/Midar.webp'
import saeiImg from '@/assets/images/prjects/SAEI.webp'
import sagImg from '@/assets/images/prjects/SAG.webp'
// import midarImg from '@/assets/images/prjects/midar.jpeg'
// import saeiImg from '@/assets/images/prjects/saei.jpeg'
// import sagImg from '@/assets/images/prjects/sag.jpeg'


function DevelopedProject() {
  return (
    <section className="portfolio-clean section-padding pt-0 ">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
        <div className="lg:col-span-4 rotate-text">
          <div className="item mb-30">
            <div className="img">
              <img src={saeiImg} alt="logo image" loading='lazy' />
              <div className="cont flex justify-between items-center text-white">
                <div>
                  <h5>SAEI</h5>
                  <p> For Indicators</p>
                </div>
                <div className="ml-auto">
                  <a href="#" className="rmore">
                  <img 
                    src="/light/assets/imgs/arrow_icon.svg"
                    alt="icon"
                    loading='lazy'
                    className="icon-img-20 ml-5 -mr-1"
                    width="40px"
                    height="40px"
                  />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-4 rotate-text">
          <div className="item mb-30">
            <div className="img">
              <img src={sagImg} alt="logo image" loading='lazy'/>
              <div className="cont flex justify-between items-center text-white">
                <div>
                  <h5>SAG</h5>
                  <p>Intelligent security solutions</p>
                </div>
                <div className="ml-auto">
                  <a href="#" className="rmore">
                  <img 
                    src="/light/assets/imgs/arrow_icon.svg"
                    alt="icon"
                    loading='lazy'
                    className="icon-img-20 ml-5 -mr-1"
                    width="40px"
                    height="40px"
                  />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-4 rotate-text">
          <div className="item md-mb30">
            <div className="img">
              <img src={midarImg} alt="logo image" loading='lazy'/>
              <div className="cont flex justify-between items-center text-white">
                <div>
                  <h5>MIDAR</h5>
                  <p>Time Share Real Estate Market</p>
                </div>
                <div className="ml-auto">
                  <a href="#" className="rmore">
                     <img 
                    src="/light/assets/imgs/arrow_icon.svg"
                    alt="icon"
                    loading='lazy'
                    className="icon-img-20 ml-5 -mr-1"
                    width="40px"
                    height="40px"
                  />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default DevelopedProject;